<div class="document-link">
  <a
    *ngIf="!disabled; else showDisabledHint"
    (click)="downloadDocument(document?.code)"
    [attr.data-cy]="'download-link-' + document?.code"
  >
    <em class="fas fa-{{ icon }}"></em> {{ title | cxTranslate }}
  </a>
  <ng-template #showDisabledHint>
    <span
      class="document-link__title-desktop"
      [ngbTooltip]="disabledHintToken | cxTranslate"
      [attr.data-cy]="'link-disabled-hint'"
    >
      <em class="fas fa-{{ icon }}"></em> {{ title | cxTranslate }}
    </span>
    <span
      class="document-link__title-mobile"
      [ngbTooltip]="disabledHintToken | cxTranslate"
      [triggers]="'click:blur'"
      [attr.data-cy]="'link-disabled-hint'"
    >
      <em class="fas fa-{{ icon }}"></em> {{ title | cxTranslate }}
    </span>
  </ng-template>
</div>
